import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import Typography from '@mui/material/Typography'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import BlockIcon from '@mui/icons-material/Block'
import WeighingModal from './WeighingModal'
import textToSpeech from '../../api/TextToSpeech'
const Weighing = ({
  id,
  response,
  condition_,
  teams_,
  stage_,
  weighing_,
  type,
}) => {
  const [condition, setCondition] = useState(null)
  const [teams, setTeams] = useState(null)
  const [stage, setStage] = useState([])
  const [weighing, setWeighing] = useState(null)
  const [weighingModalOpen, setWeighingModalOpen] = useState(false)
  const [selectedTeam, setSelectedTeam] = useState(null)
  useEffect(() => {
    setCondition(condition_)
    console.log('teams_teams_teams_', teams_)
    // Сортируем команды по sector перед сохранением
    const sortedTeams = [...(teams_ || [])].sort((a, b) => {
      // Приводим sector к числу для корректной сортировки
      const sectorA = Number(a.team?.sector) || 0
      const sectorB = Number(b.team?.sector) || 0
      return sectorA - sectorB
    })
    console.log('sortedTeamssortedTeamssortedTeamssortedTeams', sortedTeams)
    setTeams(sortedTeams)
    setStage(stage_ || [])
    setWeighing(weighing_)
  }, [condition_, teams_, stage_, weighing_])

  const handleWeighingClick = (teamId) => {
    // Обработчик нажатия на кнопку взвешивания
    console.log(`Взвешивание для команды ${teamId}`)
    // Здесь можно вызвать функцию response для сохранения данных
  }
  // Открытие модального окна
  const handleOpenWeighing = () => {
    setWeighingModalOpen(true)
  }
  // Обработка сохранения данных
  const handleSaveWeighing = (data) => {
    response(data)

    console.log('Данные взвешиваниямммм:', data)
    // Здесь можно сохранить данные в state или отправить на сервер
  }
  const handleNoCatchClick = (teamId) => {
    // Обработчик для команды без улова
    setSelectedTeam(teamId)
    console.log('Данные teamId:', teamId)
    const text =
      'Взвешивание команды ' + name(teamId) + ', сектор номер ' + teamId.sector
    textToSpeech.speak(text, {
      lang: 'ru-RU',
      rate: 0.9,
      pitch: 1,
      onStart: () => console.log('Speech started'),
      onEnd: () => console.log('Speech ended'),
      onError: (e) => console.error('Error:', e),
    })
    handleOpenWeighing()
    console.log(`Нет улова для команды ${name(teamId)}`)
  }
  const name = (team) => {
    if (type == 'Рейтинговое соревнование') return team?.team_name_ru

    return team?.preferred_name == 'en'
      ? team?.team_name_en
        ? team?.team_name_en
        : team?.team_name_ru
      : team?.team_name_ru
  }
  const colorButton = (team) => {
    if (team.zona) {
      if (team.zona === 'А') return 'error'
      else if (team.zona === 'Б') return 'warning'
      else return 'info'
    }
    return 'info'
  } //Красная, желтая, синяя
  const renderTeamButtons = () => {
    console.log('teamsteamteamsteamsteamsteamss', teams)
    if (!teams.length) return null

    return teams.map((team) => {
      const hasWeighed = stage.some(
        (item) => item.teamId === team.team.id && item.weighing === weighing
      )

      return (
        <div key={team.team.id} style={{ margin: '8px 0' }}>
          {!hasWeighed ? (
            <Button
              variant="contained"
              color={colorButton(team.team)}
              fullWidth
              onClick={() => handleNoCatchClick(team.team)}
              style={{ marginTop: '4px' }}
            >
              #{team.team.sector} {name(team.team)}
            </Button>
          ) : (
            <Button
              variant={hasWeighed ? 'contained' : 'outlined'}
              color={hasWeighed ? 'success' : 'primary'}
              fullWidth
              disabled={hasWeighed}
              startIcon={hasWeighed ? <CheckCircleIcon /> : null}
              onClick={() => handleWeighingClick(team.team.id)}
            >
              {name(team.team)} {hasWeighed && '(Уже взвешено)'}
            </Button>
          )}
        </div>
      )
    })
  }
  const weighingModal = () => {
    if (selectedTeam)
      return (
        <WeighingModal
          open={weighingModalOpen}
          onClose={() => setWeighingModalOpen(false)}
          teamName={name(selectedTeam) || ''}
          teamId={selectedTeam.id}
          sector={selectedTeam.sector}
          onSave={handleSaveWeighing}
        />
      )
  }

  const conditionBt = () => {
    if (condition && condition === 'Взвешивание') {
      return (
        <>
          <Typography variant="h6" gutterBottom>
            <b> Взвешивание</b>
          </Typography>
          <Typography variant="body1" gutterBottom>
            Все сектора должны быть взвешены. При отсутствии улова нажмите
            соответствующую кнопку.
          </Typography>
          {renderTeamButtons()}
          {weighingModal()}

          {/* {teams.} */}
          {/* <Button
            variant="outlined"
            color="secondary"
            fullWidth
            startIcon={<DoDisturbIcon />}
          >
            Закрыть взвешивание
          </Button> */}
        </>
      )
    } else if (condition && condition === 'Дополнителное') {
      return (
        <>
          <Typography variant="h6" gutterBottom>
            <b> Взвешивание</b>
          </Typography>
          {renderTeamButtons()}
          {weighingModal()}

          {/* {teams.} */}
          {/* <Button
            variant="outlined"
            color="secondary"
            fullWidth
            startIcon={<DoDisturbIcon />}
          >
            Закрыть взвешивание
          </Button> */}
        </>
      )
    } else {
      return (
        <>
          <Typography variant="h6" gutterBottom>
            <b> Взвешивание</b>
          </Typography>
          <Typography variant="body1" gutterBottom>
            Перед выбором сектора необходимо открыть взвешивание.
          </Typography>
        </>
      )
    }
  }

  return conditionBt()
}
export default Weighing
